import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import Swal from 'sweetalert2';
import { SupplyService } from '../supply.service';

@Component({
  selector: 'app-supply-overview',
  templateUrl: './supply-overview.component.html',
  styleUrls: ['./supply-overview.component.scss']
})
export class SupplyOverviewComponent implements OnInit {
  loading = false;
  productTypes: any[] = [];
  dispatchRows: any[] = [];
  analytics: any = null;

  constructor(private supplyService: SupplyService) {}

  ngOnInit(): void {
    this.loadOverview();
  }

  loadOverview(): void {
    this.loading = true;
    forkJoin({
      productTypes: this.supplyService.getProducts(),
      dispatchRows: this.supplyService.getDispatches(),
      analytics: this.supplyService.getDispatchAnalytics()
    }).subscribe({
      next: ({ productTypes, dispatchRows, analytics }) => {
        this.productTypes = productTypes || [];
        this.dispatchRows = dispatchRows || [];
        this.analytics = analytics || null;
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        Swal.fire('Error', err?.error?.message || 'Failed to load supply overview.', 'error');
      }
    });
  }

  get productItemCount(): number {
    return this.productTypes.reduce((sum, row) => sum + (row?.items?.length || 0), 0);
  }

  get totalUnits(): number {
    return this.dispatchRows.reduce((sum, row) => sum + Number(row?.unitCount || 0), 0);
  }

  get recentDispatches(): any[] {
    return [...this.dispatchRows]
      .sort((a, b) => new Date(b.dispatchDate || 0).getTime() - new Date(a.dispatchDate || 0).getTime())
      .slice(0, 6);
  }

  get topProducts(): Array<{ label: string; value: number }> {
    const map = new Map<string, number>();
    this.dispatchRows.forEach((row) => {
      const key = String(row?.productItemName || row?.productTypeName || 'Unmapped Item').trim() || 'Unmapped Item';
      map.set(key, (map.get(key) || 0) + Number(row?.unitCount || 0));
    });

    return Array.from(map.entries())
      .map(([label, value]) => ({ label, value }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 6);
  }

  get routeHighlights(): Array<{ label: string; value: number }> {
    const map = new Map<string, number>();
    this.dispatchRows.forEach((row) => {
      const key = `${row?.origin || 'Unknown'} → ${row?.destination || 'Unknown'}`;
      map.set(key, (map.get(key) || 0) + 1);
    });

    return Array.from(map.entries())
      .map(([label, value]) => ({ label, value }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 5);
  }
}
